import { z } from 'zod'
import { redirect, createFileRoute } from '@tanstack/react-router'
import { Header } from '@/components/layout/header'
import { ThemeSwitch } from '@/components/theme-switch'
import { AuthButton, useAuthStore } from '@/features/auth'
import { Review } from '@/features/review'
import { TransactionsDialog } from '@/features/transactions'

// ================================
// Route definition
// ================================

const searchSchema = z.object({
  scope: z.enum(['pending', 'draft', 'published', 'all']).catch('pending'),
  page: z.number().catch(1),
  pageSize: z.number().catch(20),
})

export const Route = createFileRoute('/_authenticated/review/')({
  validateSearch: (search) => searchSchema.parse(search),
  beforeLoad: () => {
    const { auth } = useAuthStore.getState()

    if (auth.user?.role !== 'admin' && auth.user?.role !== 'super_admin') {
      throw redirect({ to: '/403' })
    }
  },
  component: ReviewPage,
})

// ================================
// Page Component (Review shell)
// ================================

export function ReviewPage() {
  return (
    <>
      <Header>
        <div className='ms-auto flex items-center space-x-4'>
          <ThemeSwitch />
          <TransactionsDialog />
          <AuthButton />
        </div>
      </Header>

      <Review />
    </>
  )
}
